import clsx, { ClassValue } from 'clsx';
import { ComponentType } from 'react';
import { extendTailwindMerge } from 'tailwind-merge';

export type InferBaseHtmlType<T> = T extends React.DetailedHTMLProps<React.HTMLAttributes<infer R>, infer R> ? R : any;

export type ExtractHeadlessUiProps<T> = T extends ComponentType<infer P> ? P : T;

const twMergeCustom = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': ['text-xxs'],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMergeCustom(clsx(...inputs));

// https://stackoverflow.com/a/47409362/5956356
export const triggerInputChange = (node: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, value = '') => {
  const setValue = Object.getOwnPropertyDescriptor((node as any).__proto__, 'value')?.set;
  if (!setValue) return;
  setValue.call(node, value);
  node.dispatchEvent(new Event('input', { bubbles: true }));
  node.blur();
  // node.dispatchEvent(new Event('blur', { bubbles: true }));
};
